<!-- Layout card: franja de SMS en «Próximo pago» -->
<div *ngIf="layout === 'card'" class="sms-messages sms-messages--card">
    <div class="sms-messages__icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 10h8M8 14h5M21 12c0 4.97-4.03 9-9 9-1.1 0-2.15-.2-3.12-.56L3 21l1.56-4.68A8.96 8.96 0 0 1 3 12c0-4.97 4.03-9 9-9s9 4.03 9 9Z"
                stroke="#7c3aed"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </div>
    <div class="sms-messages__balance">
        <div class="sms-messages__label">SMS disponibles</div>
        <div class="sms-messages__amount">
            <span class="sms-messages__amount-n">{{ availableSms }}</span>
            <span class="sms-messages__amount-u">mensajes</span>
        </div>
    </div>
    <p class="sms-messages__hint mb-0">Se descuentan al enviar campañas de marketing y notificaciones a tus clientes.</p>
    <button type="button" class="btn sms-messages__btn-outline" *ngIf="canBuy; else onlyOwnerTpl" (click)="onBuyClick()">Comprar más SMS</button>
    <ng-template #onlyOwnerTpl>
        <p class="sms-messages__hint mb-0" data-test="sms-messages-owner-only">Solo el dueño del comercio puede comprar SMS.</p>
    </ng-template>
</div>

<!-- Layout modal: compra de paquetes -->
<div *ngIf="layout === 'modal'" class="sms-messages sms-messages--modal">
    <div class="sms-messages__banner">
        <span class="sms-messages__banner-icon" aria-hidden="true">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 10h8M8 14h5M21 12c0 4.97-4.03 9-9 9-1.1 0-2.15-.2-3.12-.56L3 21l1.56-4.68A8.96 8.96 0 0 1 3 12c0-4.97 4.03-9 9-9s9 4.03 9 9Z"
                    stroke="#7c3aed"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </span>
        <p class="sms-messages__banner-text mb-0">
            Tenés <strong>{{ availableSms }}</strong> SMS disponibles. Comprá los que necesites — se suman a tu saldo.
        </p>
    </div>

    <div *ngIf="loadingPackages" class="sms-messages__skeleton" aria-busy="true" aria-label="Cargando paquetes">
        <div class="sms-messages__packages">
            <div class="sms-messages__package sms-messages__package--skeleton" *ngFor="let _ of skeletonSlots">
                <span class="sms-messages__skel sms-messages__skel--circle"></span>
                <span class="sms-messages__skel sms-messages__skel--title"></span>
                <span class="sms-messages__skel sms-messages__skel--desc"></span>
                <span class="sms-messages__skel sms-messages__skel--price"></span>
                <span class="sms-messages__skel sms-messages__skel--unit"></span>
            </div>
        </div>
        <div class="sms-messages__summary sms-messages__summary--skeleton">
            <span class="sms-messages__skel sms-messages__skel--row"></span>
            <span class="sms-messages__skel sms-messages__skel--row"></span>
            <span class="sms-messages__skel sms-messages__skel--row sms-messages__skel--row-total"></span>
        </div>
    </div>

    <div *ngIf="!loadingPackages && packagesError" class="sms-messages__state text-danger py-4 text-center">No se pudieron cargar los paquetes de SMS.</div>

    <div *ngIf="!loadingPackages && !packagesError && packages.length === 0" class="sms-messages__state text-muted py-4 text-center">No hay paquetes de SMS disponibles por ahora.</div>

    <ng-container *ngIf="!loadingPackages && !packagesError && packages.length > 0">
        <div class="sms-messages__packages">
            <button type="button" class="sms-messages__package" *ngFor="let pkg of packages" [class.sms-messages__package--active]="selectedPackageId === pkg.id" (click)="selectPackage(pkg)">
                <span *ngIf="pkg.bestValue" class="sms-messages__best">Mejor valor</span>
                <span class="sms-messages__radio" [class.sms-messages__radio--on]="selectedPackageId === pkg.id"></span>
                <div class="sms-messages__package-qty">{{ pkg.title || pkg.quantity + ' SMS' }}</div>
                <div class="sms-messages__package-desc" *ngIf="pkg.description">{{ pkg.description }}</div>
                <div class="sms-messages__package-price">{{ pkg.priceUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</div>
                <div class="sms-messages__package-unit">{{ unitPriceLabel(pkg) }}</div>
            </button>
        </div>

        <div class="sms-messages__summary">
            <div class="sms-messages__summary-row">
                <span>Subtotal</span>
                <span>{{ subtotalUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
            </div>
            <div class="sms-messages__summary-row">
                <span>IVA (16%)</span>
                <span>{{ ivaUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
            </div>
            <div class="sms-messages__summary-row sms-messages__summary-row--total">
                <span>Total</span>
                <span>{{ totalUsd | currency : 'USD' : 'symbol' : '1.2-2' : 'en-US' }}</span>
            </div>
        </div>
    </ng-container>
</div>
